module.exports = __webpack_public_path__ + "static/media/galerija_2019 (7).07b79513.jpg";